window.Documento = Backbone.Model.extend({

});

window.Documentos = Backbone.Collection.extend({
    model: Documento
});

window.PesquisarDocumentosAberto = Backbone.Model.extend({

});
window.CreditosCliente = Backbone.Model.extend({

});